import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-5" }
const _hoisted_2 = { class: "highlight" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", {
  class: "highlight-copy btn",
  "data-bs-toggle": "tooltip",
  title: "Copy code"
}, " copy ", -1)
const _hoisted_4 = {
  class: "nav nav-pills",
  role: "tablist"
}
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "tab-content" }
const _hoisted_10 = ["id"]
const _hoisted_11 = { class: "highlight-code" }
const _hoisted_12 = { class: "language-html" }
const _hoisted_13 = { class: "language-html" }
const _hoisted_14 = ["id"]
const _hoisted_15 = { class: "highlight-code" }
const _hoisted_16 = { class: "language-js" }
const _hoisted_17 = { class: "language-js" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("ul", _hoisted_4, [
        _createElementVNode("li", _hoisted_5, [
          _createElementVNode("a", {
            class: "nav-link active",
            "data-bs-toggle": "tab",
            href: `#kt_highlight_${_ctx.htmlId}`,
            role: "tab",
            "aria-selected": "true"
          }, "HTML", 8, _hoisted_6)
        ]),
        _createElementVNode("li", _hoisted_7, [
          _createElementVNode("a", {
            class: "nav-link",
            "data-bs-toggle": "tab",
            href: `#kt_highlight_${_ctx.jsId}`,
            role: "tab",
            "aria-selected": "false"
          }, "JAVASCRIPT", 8, _hoisted_8)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", {
          class: "tab-pane fade active show",
          id: `kt_highlight_${_ctx.htmlId}`,
          role: "tabpanel"
        }, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("pre", _hoisted_12, [
              _createElementVNode("code", _hoisted_13, [
                _renderSlot(_ctx.$slots, "html")
              ])
            ])
          ])
        ], 8, _hoisted_10),
        _createElementVNode("div", {
          class: "tab-pane fade",
          id: `kt_highlight_${_ctx.jsId}`,
          role: "tabpanel"
        }, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("pre", _hoisted_16, [
              _createElementVNode("code", _hoisted_17, [
                _renderSlot(_ctx.$slots, "js")
              ])
            ])
          ])
        ], 8, _hoisted_14)
      ])
    ])
  ]))
}